import {createAction} from 'redux-actions';
import {getMrssDefaults} from '@pluto/rest';

export const MRSS_DEFAULTS_SET = 'MRSS_DEFAULTS_SET';

export const setMrssDefaultsAction = createAction(MRSS_DEFAULTS_SET, async () => {
    return await getMrssDefaults();
});
